// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"22":"374d9a4a","77":"319a067f","340":"cc4b19a6","577":"edfda426","636":"1aea7f2a"}[chunkId] + ".js";
};